<button nxButton="secondary small" type="button" class="nx-margin-bottom-0 nx-margin-right-2xs" *ngIf="userRole=='WorkShop' || DealerReg">
    <nx-icon name="product-money-suitcase" class="nx-margin-right-2xs"></nx-icon>Wallet balance : {{walletBalance }}
  </button>